module.exports = "<div [ngClass]=\"{'night-mode':!nmode, '':nmode }\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n<app-confirm></app-confirm> "